<template>
  <naj-modal
    ref="modal"
    :title="local.redistribution.modalTitle"
    :width="900"
    :footer="true"
    @onClose="closeModal"
  >
    <form class="redistribution-form">
      <naj-input
        :type-id="formFieldType.selectbox"
        :items="employees"
        :value.sync="employeeId"
        item-text="name"
        item-value="id"
        :label="local.redistribution.selectEmployee"
      ></naj-input>
    </form>
    <template
      slot="actions"
      slot-scope="{ closeNajModal }"
    >
      <naj-button
        :disabled="employeeId == null || loading"
        :loading="loading"
        @click="submit(closeNajModal)"
      >
        {{ local.common.save }}
      </naj-button>
    </template>
  </naj-modal>
</template>

<script>
import { lawsuitRedistributionDepartments } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';

const { mapActions } = createNamespacedHelpers('LawsuitModule');
const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers(
  'LookupsModule'
);

export default {
  name: 'RedistributionModal',
  props: ['modalVisibility', 'selectedRequests', 'params'],
  data () {
    return {
      employeeId: null,
      loading: false,
    };
  },
  mounted () {},
  computed: {
    ...mapLUTState(['lawsuitEmployees', 'centralAuditEmployees']),
    employees () {
      switch (this.params.departmentType) {
        case lawsuitRedistributionDepartments.lawsuit.id: {
          return this.lawsuitEmployees;
        }
        case lawsuitRedistributionDepartments.centralAudit.id: {
          return this.centralAuditEmployees;
        }
        default: {
          return [];
        }
      }
    },
  },
  methods: {
    ...mapActions(['submitLawsuitRedistribution', 'submitCentralAuditRedistribution']),
    ...mapLUTActions(['getLawsuitEmployees', 'getCentralAuditEmployees']),
    getEmployees () {
      switch (this.params.departmentType) {
        case lawsuitRedistributionDepartments.lawsuit.id: {
          return this.getLawsuitEmployees();
        }
        case lawsuitRedistributionDepartments.centralAudit.id: {
          return this.getCentralAuditEmployees();
        }
      }
    },
    submitRedistribution (payload) {
      switch (this.params.departmentType) {
        case lawsuitRedistributionDepartments.lawsuit.id: {
          return this.submitLawsuitRedistribution(payload);
        }
        case lawsuitRedistributionDepartments.centralAudit.id: {
          return this.submitCentralAuditRedistribution(payload);
        }
      }
    },
    closeModal () {
      this.$emit('onClose');
      this.resetForm();
    },
    submit () {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          this.loading = true;
          const payload = this.selectedRequests.reduce((requests, request) => {
            return requests.concat({
              newUserId: this.employeeId || null,
              objectKey: request.objectKey,
              departmentType: this.params.departmentType,
            });
          }, []);
          this.submitRedistribution(payload)
            .then(() => {
              this.loading = false;
              this.$emit('successSubmit');
              this.closeModal();
              this.toaster.success(this.local.redistribution.successMessage);
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    resetForm () {
      this.employeeId = null;
    },
  },
  watch: {
    modalVisibility (newValue) {
      if (newValue) {
        this.getEmployees();
        this.$refs.modal.show();
      } else {
        this.$refs.modal.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.headline {
  background-color: #075848 !important;
  color: #fff;
  padding: 15px 25px;
}
.redistribution-form {
  padding-top: 30px;
}
.modal-content {
  padding: 20px;
}
</style>
